import React, { useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dialog } from 'primereact/dialog';
import { Steps } from 'primereact/steps';
import { SelectButton } from 'primereact/selectbutton';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import InputUpload from "../../components/sturtural/InputUpload";
import { storage } from '../../helpers/storage';

const Uniforme = () => {

    const [formTalla, setFormTalla] = useState(true);
    const [formIndentificacion, setFormIdentificacion] = useState(false);
    const [formFirma, setFormFirma] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);
    const [displayConfirmation, setDisplayConfirmation] = useState(false);
    
    const [tallas, setTallas] = useState(null);
    const [prendas, setPendas] = useState(null);
    const [loadSelectValue1, setLoadSelectValue1] = useState(null);
    const [errorSelectValue1, setErrorSelectValue1] = useState(null);
    
    const [selectButtonValue, setSelectButtonValue] = useState({});
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);

    const [alumno, setAlumno] = useState(null);
    const [load_alumno, setLoad_alumno] = useState(false);

    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);

    const [loading, setLoading] = useState(false);
    const [resumen, setResumen] = useState(false);

    const canvasRef = useRef(null);

    const [drawing, setDrawing] = useState(false);
    const ctxRef = useRef(null);

    const navigate = useNavigate();

    const ciclo = storage.get('ciclo');

    let {q} = useParams();
    let {e} = useParams();
    let {f} = useParams();
    
    let url1 = `${BASE_API}BusquedaAlumnos/BusquedaxFolio`;
    useEffect(() => {
        const arrUser = {
            "Folio": f
        };

        setLoad_alumno(true);
        helpHttp().post(url1, {
            body: arrUser,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if(!res.err) {
                let arrAlumno = res.Result;

                if(arrAlumno.IdEstatus === 2) {
                    navigate(`/filtro/na`);
                }

                setAlumno(arrAlumno);

                handleGet_CatalogoTallas(arrAlumno.IdNivel, arrAlumno.IdGenero);
            } else {
                setAlumno(null)
            }
            setLoad_alumno(false);
        });
    },[f]);
    
    const handleGet_CatalogoTallas = (IdNivel, IdGenero) => {
        const arrParams = {
            "IdNivel": IdNivel,
            "IdGenero": IdGenero,
            "IdCicloEscolar": ciclo.IdCicloEscolar
        }

        setLoadSelectValue1(true);
        helpHttp().post( `${BASE_API}Prendas/CargarCatalogo`, {
            body: arrParams,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if(!res.err) {

                const prendas = [... new Set(res?.map(item => 
                    item.Prenda
                ))];

                setTallas(res.map(x => ({...x, IdAlumno: q})));
                setPendas(prendas);
                setErrorSelectValue1(null);
            } else {
                //setSelectButtonValue1(null);
                setErrorSelectValue1(res);
            }
            setLoadSelectValue1(false);
        });
    }

    const wizardItems = [
        { 
            label: 'Prendas', 
            command: () => redirects(true, false, false)
        },
        { 
            label: 'Identificación', 
            command: () => redirects(false, true, false)
        },
        { 
            label: 'firma', 
            command: () => redirects(false, false, true)
        },
        //{ label: 'Resumen', command: '' }
    ];

    const redirects = (talla, identificacion, firma) => {
        setFormTalla(talla);
        setFormIdentificacion(identificacion);
        setFormFirma(firma);
    }

    const handlerRedirect = () => {
        if(resumen){
            navigate(`/resumen/${window.btoa(q)}`);
        } else {
            setMessage(null);
            setAviso(false)
        }
    }

    const handleSelection_talla = (value) => {
        if(value){
            let obj = selectButtonValue;
            obj[value.Prenda]=value;
            setSelectButtonValue({});
            setSelectButtonValue({...obj});
        }
    }

    const handleSelectionValue = prenda => {   
        let value = selectButtonValue[prenda];
        return value;
    }

    const handleClick_siguienteTallas = () => {
        let seleccion = prendas.map(x=>selectButtonValue[x]).filter(y=>y!==undefined)
        let nprendas = prendas.length;

        let selectValue = seleccion.length;

        if(selectValue === nprendas) {
            setActiveIndex(1);
            setFormTalla(false);
            setFormIdentificacion(true);
            setFormFirma(false);
        } else {
            setMessage("Debe seleccionar la talla de todos los articulos.");
            setAviso(true);
        }
    }

    const handleClick_siguienteIdentificacion = () => {
        if(frontal && reverso) {
            setActiveIndex(2);
            setFormTalla(false);
            setFormIdentificacion(false);
            setFormFirma(true);

            console.log('checando firma');
            document.body.style.overflow = "hidden";
        } else {
            // 
            setMessage('Debe cargar las imagenes de su identificación');
            setAviso(true);
        }
    }

    const handleSubmit_finalizar = () => {
        document.body.style.overflow = 'auto';
        const arrhologramas = {
            "IdEncEntrega": e,
            "IdEncEntregaArray": [e], 
            "DetEntrega": prendas.map(x=>selectButtonValue[x]).filter(y=>y!==undefined),
            "IdUsuario": storage.get('id'),
            "FotoFrente": frontal.split(',')[1],
            "FotoReverso": reverso.split(',')[1],
            "FotoFirma": getFirmaB64().split(',')[1],
            "FechaModificacion": "", 
            "IdTutorSeleccionado": storage.get('IdTutor'), 
            "IdAlumno": q,
            "IdEstatus": 2,
            "IdMotivoCancelacion": 0, 
            "OtroMotivoCancelacion": "", 
            "IdAlumnosArray": [q],
            "JustificacionDeCancelacion": "", 
            "IdTipoDocumento":1,
            "IdDocumento": 1,
            "IsEntrega": true,
            "IdCicloEscolar": ciclo.IdCicloEscolar
        }
        setLoading(true);
        helpHttp().post(`${BASE_API}Entrega/ConfirmarEntrega`, {
            body: arrhologramas,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            if(res.isSuccess === true) {
                setMessage('Uniforme entregado correctamente');
                setResumen(true);
                setAviso(true);
            } else if(res.isSuccess === false) {
                console.log(res.Mensaje);
                setMessage('(1) Ocurrió un error al intentar realizar este proceso');
                setAviso(true);
            } else {
                setMessage('(2) Ocurrió un error al intentar realizar este proceso');
                setAviso(true);
            }
            setLoading(false);
        });
    }

    const confirmationDialogFooter = (
        <>
            <div className="flex pt-3">
                <div className="w-6 pr-2">
                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => setDisplayConfirmation(false)}>
                        <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
                <div className="w-6 pl-2">
                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handlerRedirect()}>
                        <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
            </div>
        </>
    );

    const handleSelectionFrontal = base64 => {
        setFrontal(base64);
    }

    const handleSeleccionReverso = base64 => {
        setReverso(base64);
    }

    useEffect(() => {
        if(formFirma) {
            //document.body.style.overflow = 'hidden';
            let width = window.innerWidth - 90;

            const canvas = canvasRef.current;
            // For supporting computers with higher screen densities, we double the screen density
            canvas.width = width * 2;
            canvas.height = 300 * 2;
            
            canvas.style.width = `${width}px`;
            canvas.style.height = `300px`;
            // Setting the context to enable us draw
            const ctx = canvas.getContext('2d');
            ctx.scale(2, 2);
            ctx.lineCap = 'round';
            ctx.strokeStyle = 'blue';
            ctx.lineWidth = 2;
            ctx.shadowBlur = 2 / 1;
            ctxRef.current = ctx;
        }
    }, [formFirma]);

    const getPositionOnCanvas = (event) => {
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        const { offsetLeft, offsetTop } = event.target;
        const canvasX = clientX;
        const canvasY = clientY;
        const posicion = canvasRef.current.getBoundingClientRect();
        const nuevaPosicionX = canvasX - posicion.x;
        const nuevaPosicionY = canvasY - posicion.y;
  
        return { x: nuevaPosicionX, y: nuevaPosicionY };
    }

    const startDraw = ({ nativeEvent }) => {
        const position = getPositionOnCanvas(nativeEvent);
        //const { offsetX, offsetY } = nativeEvent;
        ctxRef.current.beginPath();
        ctxRef.current.moveTo(position.x, position.y);
        setDrawing(true);
    };

    const stopDraw = () => {
        ctxRef.current.closePath();
        setDrawing(false);
    };
    
    const draw = ({ nativeEvent }) => {
        if (drawing){
            const position = getPositionOnCanvas(nativeEvent);
            ctxRef.current.lineTo(position.x, position.y);
            ctxRef.current.stroke();
        }
    };
    
    const clear = () => {
        ctxRef.current.clearRect(
          0,
          0,
          canvasRef.current.width,
          canvasRef.current.height
        );
    };

    const draww = (ctx, frameCount) => {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.fillStyle = 'blue';
        ctx.beginPath();
        ctx.arc(170, 50, 30 * Math.sin(frameCount * 0.05) ** 2, 0, 2 * Math.PI);
        ctx.fill();
    };

    const getFirmaB64 = () => {
        return canvasRef.current?.toDataURL();
    }

    const firmaValida = () => {
        return canvasRef.current?.getContext('2d').getImageData(0, 0, canvasRef.current.width, canvasRef.current.height).data
        .some(channel => channel !== 0);
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button-secondary" />;

    const mensajeOmicion = () => {
        setMessage("Has omitido la firma digital");
        setAviso(true);
    }
    return (
        <>
            <Menu link='nueva-solicitud' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <Steps model={wizardItems} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} /><br/>
                        {load_alumno ? <div><Loader /></div>: 
                            <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 border-1 mb-3" style={{"borderRadius": "10px", "backgroundColor": "rgba(33, 197, 94, 0.1)", "borderColor": "rgba(33, 197, 94, 0.5)"}}>
                                <div>
                                    <div>
                                        <span className="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1" style={{"borderColor": "rgba(33, 197, 94, 0.5)"}}><i className="pi pi-user text-green-600"></i></span>
                                        <span className="text-green-700 font-bold ml-2">{alumno?.Nombre} {alumno?.ApellidoPaterno} {alumno?.ApellidoMaterno}</span>
                                    </div>
                                    <p className="text-green-700 mt-2 mb-0">Escuela <span className="font-medium">{alumno?.Grado} {alumno?.Grupo}</span></p>
                                </div>
                            </li>}
                    </div>
                </div>            

                {formTalla && 
                <div className="col-12">
                    <div className="card">
                        <div className="grid">
                            <div className="col-12">
                                    {loadSelectValue1 && <Loader />}
                                    {prendas && prendas.map((prenda, index) => 
                                        <Panel header={prenda} className='mb-3' key={`panel-${index}`}>
                                            {tallas && 
                                                <SelectButton 
                                                    value={ handleSelectionValue(prenda)}
                                                    onChange={(e) => handleSelection_talla(e.value)} 
                                                    options={tallas.filter(x => x.Prenda === prenda)} 
                                                    optionLabel="Talla" />
                                            }
                                        </Panel>
                                    )}
                            </div>
                        </div>
                        <div className="px-4 py-3 surface-100 text-right">
                            <Button label="Siguiente" icon='pi pi-arrow-circle-right' className="p-button-rounded mr-2 mb-2" onClick={() => handleClick_siguienteTallas()} />
                        </div>
                    </div>
                </div>}

                {formIndentificacion && 
                <div className="col-12">
                    <div className="col-12 p-3">
                        <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                            <div className="p-4">
                                <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{'width': "48px",'height': "48px",'borderRadius': "10px"}}>
                                    <i className={`pi pi-camera text-xl text-gray-600`}></i>
                                </span>
                                <span className="text-900 font-medium text-2xl">
                                    CAPTURA FRONTAL
                                </span>
                            </div>

                            <div className='col-12'>
                                <img 
                                    style={{'display':'block', 'width':'100%','height':'100%'}} 
                                    id='base64image' 
                                    src={frontal}>
                                </img>
                            </div>
                                
                            <div className="px-4 py-3 surface-100 text-right">
                                <div className="input-group">
                                    <InputUpload 
                                        usuarioid={storage.get('id')} 
                                        handleSelection={handleSelectionFrontal} />
                                </div>
                            </div>
                            {/*<div className="px-4 py-3 surface-100 text-right">
                                <Button label="Limpiar" className="p-button-rounded mr-2 mb-2" onClick={() => setFrontal(null)} />
                            </div>*/}
                        </div>
                    </div>

                    <div className="col-12 p-3">
                        <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                            <div className="p-4">
                                <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{'width': "48px",'height': "48px",'borderRadius': "10px"}}>
                                    <i className={`pi pi-camera text-xl text-gray-600`}></i>
                                </span>
                                <span className="text-900 font-medium text-2xl">
                                    CAPTURA REVERSO
                                </span>
                            </div>

                            <div className='col-12'>
                                <img 
                                    style={{'display':'block', 'width':'100%','height':'100%'}} 
                                    id='base64image' 
                                    src={reverso}>
                                </img>
                            </div>
                                
                            <div className="px-4 py-3 surface-100 text-right">
                                <div className="input-group">
                                    <InputUpload 
                                        usuarioid={storage.get('id')} 
                                        handleSelection={handleSeleccionReverso} />
                                </div>
                            </div>
                            {/*<div className="px-4 py-3 surface-100 text-right">
                                <Button label="Limpiar" className="p-button-rounded mr-2 mb-2" onClick={() => setReverso(null)} />
                            </div>*/}
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="px-4 py-3 surface-100 text-right">
                            <Button label="Siguiente" icon='pi pi-arrow-circle-right' className="p-button-rounded mr-2 mb-2" onClick={() => handleClick_siguienteIdentificacion()} />
                        </div>
                    </div>
                </div>}

                {formFirma &&
                <div className="col-12">
                    <div className="col-12  p-3">
                        <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                            <div className="p-4">
                                <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{'width': "48px",'height': "48px",'borderRadius': "10px"}}>
                                    <i className={`pi pi-pencil text-xl text-gray-600`}></i>
                                </span>
                                <span className="text-900 font-medium text-2xl">
                                    FIRMA ELECTRONICA
                                </span>
                            </div>
                            
                            <div className='col-12' style={{'height': "310px"}}>
                                <canvas 
                                    ref={canvasRef} 
                                    id="drawing-area"
                                    onMouseDown={startDraw}
                                    onMouseUp={stopDraw}
                                    onMouseMove={draw}
                                    
                                    onTouchStart={startDraw}
                                    onTouchMove={draw}
                                    onTouchEnd={stopDraw}
                                    style={{"border": "1px solid black"}}>
                                </canvas>
                            </div>
                                
                            <div className="px-4 py-3 surface-100 text-right">
                                <Button label="Limpiar" className="p-button-rounded mr-2 mb-2" onClick={() =>clear()} />
                                <Button label="Finalizar" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner': 'pi pi-arrow-circle-right')} className="p-button-rounded mr-2 mb-2" onClick={() => firmaValida()?handleSubmit_finalizar():mensajeOmicion()} />
                            </div>
                        </div>
                    </div>
                </div>}
            </div>

            <Dialog header="Confirmación" visible={displayConfirmation} onHide={() => setDisplayConfirmation(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Cuenta con indentificación oficial?
                    </span>
                </div>
            </Dialog>

            <Dialog header="Aviso" visible={aviso} onHide={() => handlerRedirect} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default Uniforme;